import { AppSettingsService } from "src/app/services/Index";

export async function CheckGroupPermissions (groupName: string) {
	const groups = await AppSettingsService.get("groups");
	const groupArray = groups?.split(",");

	return groupArray?.includes('Super Administrators') || groupArray?.includes(groupName);
}